module.exports = "https://r.nearpod.com/assets/media/image/pdf-48eec1e8a0ff06d7fbcb1b87693815ac.svg";